export default __webpack_public_path__ + "static/media/vigot-screenshot-02.719a0435.png";